// @modifed : change like v2.0.0
// @version V0.0.2 [Tuesday - 20201103_090903] : added authorize page, vue-progress, vuex predata, has meta.isActionRoute to identify
// @version V0.0.1 [Wednesday - 20201028_093630] : init

// vue router global hook
// router hook, should place before Vue Instance Created
import { router } from "./loadVueRouter";
import { store } from "./loadVueX";
// import {  } from "@/fadel/vuex/api";
import { notify } from "./../asahi/vuex/api";

router.beforeEach(async (to, from, next) => {
    // load vuex predata if need
    if (!store.state.authUser.fetched) {
        await store.dispatch('authUser/refreshAuth')
    }
    
    // vue instance as app, may be call after Vue Init
    if (!_.isEmpty(app)) {     
        // vue progress bar
        app.$Progress.start();
    }

    // guest organized in be
    let permit = _.some(store.state.authUser.detail.role.pages, p => p.key === to.name)
    if (!permit) {
        notify('error', 'belum ada izin akses...')
        return false
    }

    next()
}) 

router.afterEach((to, from) => {
    // #

    // vue instance as app, may be call after Vue Init
    if (!_.isEmpty(app)) {
        // vue progress bar
        app.$Progress.finish();
    }
    
})
